export default __webpack_public_path__ + "static/media/to_delete9.fccd0897.png";